import pre from './pre';
import post from './post';
import config from './config/index.vue';
import addon from './addon.vue';
import success from './success.vue';

export default {
  pre,
  components: {
    config,
    addon,
    success
  },
  post,
};
